/*TICKET EDITOR*/
Vue.component('ticketeditor',{
    template:'#ticketeditor-template',
    data:function(){
        return{
            client: [],
            project: [],
            backupRecord:[],
            brands:[],
            subBrands:[],
            activeClient:'',
            activeBrand:'',
            activeBrandId:'',
            activeSubBrand:'',
            activeSubBrandId:'',
            projectName:'',
            projectDeadLine:'',
            projectStart:'',
            projects:'',
            ticket: {
                name: '',
                assignees: [],
                brief:[],
            },
            recentProjectNumbers:[],
            completionMonth:'',
            briefTemplates:[],
            projectBriefTemplates:[],
            activeDivision:[],
            activeDivisionId:'',
            dropZoneInstance:'',
            dropZoneFiles:[],
            project_id:'',
            ticket_id:'',
            maxFileSize: 80,/* MB */
            deadline:'',
            has_deadline:false,
            phase_list: [],
            invoice_required: null,
            last_url:''
        };
    },
    created:function(){

        activeInstance = this;

        activeInstance.getBriefTemplates();

        setTimeout(function(){
            activeInstance.project_id = $('#project_id').val();
            activeInstance.ticket_id = $('#ticket_id').val();
            activeInstance.loadProjectDetails();
            activeInstance.loadTicketDetails();
            activeInstance.loadPhaseList();
            activeInstance.loadTitle();
            activeInstance.getLastURL();
        },300);

        setTimeout(function(){
            $(function () {
                $('#datetimepicker6').datetimepicker({
                    format: 'YYYY-MM-DD HH:00',
                    locale: 'hu'
                });
            });
        },300);

        setTimeout(function(){

            var token = $("meta[name='csrf-token']").attr('content');
            // Dropzone class:
            activeInstance.dropZoneInstance = $("#dropzone").dropzone({
                url: baseURL+'/admin/project/brief/file_upload',
                addRemoveLinks: true,
                maxFilesize: activeInstance.maxFileSize,
                headers: {
                    'X-CSRF-TOKEN': token
                },
                addedfile: function(file) {
                    //console.log('e');
                    // Now attach this new element some where in your page
                },
                init: function() {
                    this.on("addedfile", function(file, response) {

                        //console.log("filesize "+file.size);

                        if (file.size > activeInstance.maxFileSize * 1000000) {
                            errorNotification("Túl nagy file. Megengedett maximális méret: " + activeInstance.maxFileSize + "MB");
                            return;
                        }

                        // PREVENT FILE DUPLICATES
                        if (this.files.length) {
                            var _i, _len;
                            for (_i = 0, _len = this.files.length; _i < _len - 1; _i++) // -1 to exclude current file
                            {
                                if(this.files[_i].name === file.name && this.files[_i].size === file.size && this.files[_i].lastModifiedDate.toString() === file.lastModifiedDate.toString())
                                {
                                    errorNotification("Ezt a file-t már feltöltötted a kommenthez.");
                                    return false;
                                }
                            }
                        }

                        var fileRecord = {};
                        fileRecord.name = file.name;
                        fileRecord.progress = 0;
                        fileRecord.bytesSent = 0;
                        fileRecord.file = file;
                        fileRecord.file_record_id = '';
                        activeInstance.dropZoneFiles.push(fileRecord);
                    });
                    this.on("error", function(file, response) {
                        console.log('error:');
                        console.log(response);
                    });
                    this.on("success", function(file, response) {
                        $.each(activeInstance.dropZoneFiles,function(index,dropZoneFile){
                            if(dropZoneFile.name==file.name){
                                dropZoneFile.file_record_id=response;
                            }
                        });
                    });
                    this.on("uploadprogress", function(file) {
                        $.each(activeInstance.dropZoneFiles,function(index,dropZoneFile){
                            if(dropZoneFile.name==file.name){
                                dropZoneFile.progress=file.upload.progress;
                                dropZoneFile.bytesSent=file.upload.bytesSent;
                            }
                        });
                        console.log(file);
                        console.log(file.name);
                        console.log(file.upload.progress);
                        console.log(file.upload.bytesSent);
                    });
                }
            });
            $('#dropzone').addClass('dropzone');

        },200);

    },
    events: {
        //ON CLIENT SELECTION
        'autocomplete-result:selected': function(data){
            activeInstance.activeClient = data;
            activeInstance.getClientBrands(data.id);
        },

        //ON USER SELECTION -> ADD USER (IF NOT ALREADY ASSIGNED)
        'autocomplete-user:selected': function(data){

            var found = false;

            $.each(activeInstance.ticket.assignees, function(index,assignee){
                if (data.id == assignee.id) {
                    found = true;
                }
            });

            if (found == false) {
                activeInstance.ticket.assignees.push(data);
            }

            setTimeout(function() {
                $('#assignees').val('');
            },60);

        }
    },
    methods:{
        loadTitle:function(){
            setTimeout(function(){
                document.title = activeInstance.project.name+' - ODIN Enterprise Manager';
                //$("#page_title").text(activeInstance.project.brand.name.toUpperCase()+' / '+activeInstance.project.name.toUpperCase());
                $("#page_title").text(activeInstance.ticket.name);
            },100);

        },
        redirectToLastURL:function(){
            axios.post(baseURL+'/api/user/clear_last_url').then(function(response){
                window.location = activeInstance.last_url;
            });
        },
        loadPhaseList: function() {
            showLoadingOverlay();
            axios.get(baseURL+'/api/ticket/phase/list')
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    activeInstance.phase_list = response.data;
                })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);

                });
        },
        closeTicket: function(ticket) {
            bootbox.confirm('Biztosan lezárod a(z) ' + ticket.name + ' ticketet?', function (value) {
                if (value == true) {

                    if (activeInstance.project.billing_type == "project_based") {
                        bootbox.confirm({
                            message: "Igényel számlázást a ticket?",
                            buttons: {
                                confirm: {
                                    label: 'Igen',
                                    className: 'btn-success'
                                },
                                cancel: {
                                    label: 'Nem',
                                    className: 'btn-danger'
                                }
                            },
                            callback: function (result) {
                                ticket.invoice_required = result;
                                activeInstance.processTicketClose(ticket);
                            }
                        });
                    } else {
                        activeInstance.project_closing_is_active=true;
                    }
                }
            });
        },
        getLastURL:function(){
            axios.get(baseURL+'/api/user/last_url')
                .then(function(response){
                    activeInstance.last_url = response.data
                });
        },
        redirectToLastURL:function(){
            axios.post(baseURL+'/api/user/clear_last_url').then(function(response){
                window.location = activeInstance.last_url;
            });
        },
        processTicketClose: function(ticket) {
            $('body').LoadingOverlay("show");
            axios.post(baseURL + '/admin/project/ticket/close', {
                'ticket_id': ticket.id,
                'invoice_required':ticket.invoice_required
            })
            //ON SUCCESS
            .then(function (response) {
                $('body').LoadingOverlay("hide");
                if (response.data == "OK") {
                    ticket.phase = "client_approved";
                    window.location = baseURL + '/';
                }
            })
            //ON ERROR
            .catch(function (error, response) {
                $('body').LoadingOverlay("hide");
                bootbox.alert("Váratlan hiba történt a ticket zárása közben.");
            });
        },
        openTicket:function(ticket){
            showLoadingOverlay();
            axios.post(baseURL+'/admin/project/ticket/open', {
                'ticket_id':ticket.id
            })
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    console.log(response);
                    ticket.status='open';
                })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);

                });
        },
        //REMOVE AN ASSIGNEE
        removeAssignee:function(assignee){
            activeInstance.ticket.assignees.$remove(assignee);
        },
        //DELETE A FILE ATTACHMENT
        deleteFileAttachment:function(file){
            showLoadingOverlay();
            axios.post(baseURL+'/admin/project/brief/remove_uploaded_file_id', {
                file_record_id: file.file_record_id
            }).then(function (response) {
                $('body').LoadingOverlay("hide");
                activeInstance.dropZoneFiles.$remove(file);
            })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);
                });
        },
        //GET THE BRIEF TEMPLATES FOR DIVISIONS
        getBriefTemplates:function(){

            //GET TICKET BRIEF TEMPLATES
            showLoadingOverlay();
            axios.get(baseURL+'/api/division_brief_templates?type=ticket')
                .then(function(response){
                    $('body').LoadingOverlay("hide");
                    activeInstance.briefTemplates = response.data;
                });

            //GET PROJECT BRIEF TEMPLATES
            showLoadingOverlay();
            axios.get(baseURL+'/api/division_brief_templates?type=project')
                .then(function(response){
                    $('body').LoadingOverlay("hide");
                    activeInstance.projectBriefTemplates = response.data;
                });
        },
        //IMPORT BRIEF TEMPLATE ACCORDING TO THE SELECTED DIVISION
        importDivisionBriefTemplate:function(){
            var division_id = activeInstance.activeDivisionId;
            $.each(activeInstance.briefTemplates,function(index,division){
                console.log(division);
                if(division.id == division_id){
                    activeInstance.activeDivision = division;
                }
            });
            activeInstance.importProjectBriefValues();
        },
        //IMPORT PROJECT BRIEF VALUES INTO THE BRIEF TEMPLATE
        importProjectBriefValues:function(){

            //GET THE PROJECT BRIEF FOR THE ACTIVE DIVISION
            $.each(activeInstance.projectBriefTemplates,function(index_zero,project_brief_division){
                //console.log('pbf:');
                //console.log(activeInstance.activeDivision.id);

                if(project_brief_division.id == activeInstance.activeDivision.id) {

                    //INJECT VALUES FROM PROJECT BRIEF TEMPLATES TO THE PROJECT BRIEFS
                    $.each(project_brief_division.brief_template,function(index_one,division_brief_field){

                        $.each(activeInstance.project.project_brief,function(index_two,project_brief_field){

                            if(division_brief_field.brief_field_id == project_brief_field.brief_field_id){
                                division_brief_field.field_data.value = project_brief_field.value;
                            }
                        });
                    });

                    //INJECT PROJECT BRIEF TO THE ACTIVE DIVISION
                    activeInstance.activeDivision.project_brief_template = project_brief_division.brief_template;
                }
            });
        },
        importTicketBriefValues:function(){
            //console.log('brief:!!!');
            //console.log(activeInstance.ticket.brief);
            $.each(activeInstance.ticket.brief, function(index,ticket_brief_field){
                $.each(activeInstance.activeDivision.brief_template,function(index2,division_brief_field){
                    if(ticket_brief_field.brief_field_id == division_brief_field.brief_field_id){
                        division_brief_field.field_data.value = ticket_brief_field.value;
                    };
                });
            });
        },
        //LOAD PROJECT DETAILS
        loadProjectDetails:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL + '/api/project/list/one/'+activeInstance.project_id,function(response){

                $('body').LoadingOverlay("hide");

                response.start= response.start.substring(0,10);
                response.deadline= response.deadline.substring(0,10);
                activeInstance.project = response;

                activeInstance.activeClient = response.client;
                activeInstance.getClientBrands();
                activeInstance.activeBrand = response.brand;
                activeInstance.activeSubBrand = response.sub_brand;
                activeInstance.activeBrandId=response.brand_id;
                activeInstance.activeSubBrandId=response.sub_brand_id;
                activeInstance.activeDivisionId=response.division_id;

                setTimeout(function(){
                    activeInstance.importDivisionBriefTemplate();
                },200);

                $('#clientsearchfield').val(activeInstance.project.client.name);

                /*
                $.each(activeInstance.project.files,function(index,file){
                    var dropZoneFile = {};
                    dropZoneFile.progress = 100;
                    dropZoneFile.file_record_id = file.id;
                    dropZoneFile.name = file.filename;
                    activeInstance.dropZoneFiles.push(dropZoneFile);
                });
                */

                showLoadingOverlay();
                activeInstance.$http.get(baseURL+'/api/sub_brand/list/brand/'+activeInstance.activeBrand.id).then(function(response){
                    $('body').LoadingOverlay("hide");
                    activeInstance.subBrands = response.data;

                    activeInstance.activeBrandId = $(event.target).val();
                    $.each(activeInstance.subBrands, function(index,sub_brand){
                        console.log('searching...');

                        if(sub_brand.id==activeInstance.activeSubBrandId){
                            console.log('found...');
                            activeInstance.activeSubBrand = sub_brand;
                        }
                    });
                }).bind(this);
            });
        },
        loadTicketDetails:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL + '/api/ticket/'+activeInstance.ticket_id,function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.ticket = response;

                if(activeInstance.ticket.project_stage==null){
                    activeInstance.ticket.project_stage_id = -1;
                }

                $.each(activeInstance.ticket.files,function(index,file){
                    var dropZoneFile = {};
                    dropZoneFile.progress = 100;
                    dropZoneFile.file_record_id = file.file_record_id;
                    dropZoneFile.name = file.filename;
                    activeInstance.dropZoneFiles.push(dropZoneFile);
                });

                setTimeout(function(){
                    //activeInstance.importDivisionBriefTemplate();
                    activeInstance.importTicketBriefValues();
                },400);

                //$('#clientsearchfield').val(activeInstance.project.client.name);

                /*
                $.each(activeInstance.project.files,function(index,file){
                    var dropZoneFile = {};
                    dropZoneFile.progress = 100;
                    dropZoneFile.file_record_id = file.id;
                    dropZoneFile.name = file.filename;
                    activeInstance.dropZoneFiles.push(dropZoneFile);
                });
                */
            });
        },
        edit:function(project){
            location.href = baseURL+'/admin/project/edit/'+project.id;
        },
        destroy:function(project){
            bootbox.confirm('Biztosan el akarod távolítani ezt a céget?', function(value){
                if(value!=null){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/project/destroy',{project:project}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        successNotification('A projekt törölve.');
                        activeInstance.list.$remove(project);
                    });
                }
            });
        },
        //GET BRANDS BELONGS TO A CLIENT
        getClientBrands:function(){
            activeInstance.$http.get(baseURL+'/api/brand/list/client/'+activeInstance.activeClient.id).then(function(response){
                activeInstance.brands = response.data;
            }).bind(this);
        },
        //GET SUB BRANDS BELONGS TO A BRAND
        getBrandSubBrands:function(event,data){

            activeInstance.activeBrandId = $(event.target).val();

            $.each(activeInstance.brands, function(index,brand){
                console.log('searching...');

                if(brand.id==activeInstance.activeBrandId){
                    console.log('found...');
                    activeInstance.activeBrand = brand;
                }
            });

            activeInstance.$http.get(baseURL+'/api/sub_brand/list/brand/'+activeInstance.activeBrand.id).then(function(response){
                activeInstance.subBrands = response.data;
            }).bind(this);

        },
        setActiveSubBrand:function(event){

            var subBrandId = $(event.target).val();

            $.each(activeInstance.subBrands, function(index,sub_brand){
                console.log('searching...');

                if(sub_brand.id==subBrandId){
                    console.log('found...');
                    activeInstance.activeSubBrand = sub_brand;
                }
            });
        },
        phaseChange: function(point) {
            if (activeInstance.ticket.phase.machine_name == point.machine_name) {
                return;
            }

            if (activeInstance.ticket.phase.machine_name == 'completed') {
                bootbox.alert("Nincs jogosultságod a ticket státuszát változtatni.");
                return;
            }

            if (point.machine_name == 'completed') {
                bootbox.alert("A ticketet kizárólag a pénzügy zárhatja véglegesen.");
                return;
            }

            bootbox.confirm("Biztosan átváltod a fázist a következőre: "+point.name+"?",
                function(result){
                    if (result) {

                        if (point.machine_name == 'client_approved') {
                            bootbox.confirm({
                                message: "Igényel számlázást a ticket?",
                                buttons: {
                                    confirm: {
                                        label: 'Igen',
                                        className: 'btn-success'
                                    },
                                    cancel: {
                                        label: 'Nem',
                                        className: 'btn-danger'
                                    }
                                },
                                callback: function(result) {
                                    activeInstance.invoice_required = result;

                                    activeInstance.phaseChangePost(point);

                                    return;
                                }
                            });
                        } else {
                            activeInstance.phaseChangePost(point);
                        }
                    }
                });
        },
        phaseChangePost: function(point) {
            showLoadingOverlay();
            axios.post(baseURL+'/api/ticket/set/phase', {
                ticket_id: activeInstance.ticket.id,
                phase_machine_name: point.machine_name,
                invoice_required: activeInstance.invoice_required
            }).then(function (resp) {
                $('body').LoadingOverlay("hide");

                activeInstance.ticket.phase = point;
            }).catch(function (error) {
                $('body').LoadingOverlay("hide");
                console.log(error);
            });
        },
        save:function(){

            var files = jQuery.extend(true, {}, activeInstance.dropZoneFiles);

            $.each(files,function(index,file){
                delete file.file;
            });

            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/project/ticket/update',{
                'project_id':activeInstance.project_id,
                'ticket_id':activeInstance.ticket.id,
                'name':activeInstance.ticket.name,
                'assignees':activeInstance.ticket.assignees,
                'brief_data': activeInstance.activeDivision.brief_template,
                'files':files,
                'deadline':activeInstance.ticket.deadline,
                'project_stage_id':activeInstance.ticket.project_stage_id
            }).then(function(response){
                $('body').LoadingOverlay("hide");
                $('.form-control.error').removeClass('error');
                setTimeout(function() {

                    var redirect_url = activeInstance.$root.generateTicketUrl(activeInstance.project, activeInstance.ticket);
                    if(activeInstance.last_url.length>1){
                        redirect_url = activeInstance.last_url;
                        axios.post(baseURL+'/api/user/clear_last_url').then(function(response){
                            successNotification('Sikeres mentés');
                            window.location = redirect_url;
                        });
                    }
                    else{
                        window.location = redirect_url;
                    }
                },300);
            })
            .catch(function (error, data) {
                $('body').LoadingOverlay("hide");
                $.each(error.data,function(key, value){
                    errorNotification(value);
                    console.log(key);
                    $('#'+key).addClass('error');
                });
                console.log(error.response.data);
            });
        }
    }
});